module.exports = __webpack_public_path__ + "static/media/nav-about.39c906ee.png";